import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IntegrationsLinksComponent} from 'app/features/integrations/features/integrations-head/components/integrations-links/integrations-links.component';
import {SharedModule} from 'app/shared/shared.module';
import {ApiModule} from 'app/shared/modules/api/api.module';
import {RouterModule} from '@angular/router';

@NgModule({
    imports: [CommonModule, SharedModule, ApiModule, RouterModule],
    declarations: [IntegrationsLinksComponent],
    exports: [IntegrationsLinksComponent],
})
export class IntegrationsHeadModule {}
